import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";

const AGB = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-concrete-900">
      {/* Back Button Header */}
      <div className="fixed top-0 left-0 right-0 bg-white border-b border-concrete-200 z-50">
        <div className="container mx-auto px-4 py-4">
          <Link to="/">
            <Button variant="ghost" className="gap-2 text-black hover:bg-concrete-100">
              <ArrowLeft size={20} /> Zurück zur Website
            </Button>
          </Link>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-32 max-w-4xl">
        <h1 className="text-4xl font-heading font-bold mb-8 text-black">Allgemeine Geschäfts- und Lieferbedingungen</h1>
        <p className="text-concrete-500 mb-8">Bürokult GmbH</p>
        
        <div className="prose prose-lg prose-neutral max-w-none">
          <h2>§ 1 Angebot und Vertragsabschluss</h2>
          <p>Die vom Besteller unterzeichnete Bestellung ist ein bindendes Angebot. Wir können dieses Angebot innerhalb von zwei Wochen durch Zusendung einer Auftragsbestätigung annehmen oder innerhalb dieser Frist die bestellte Ware zusenden.</p>

          <h2>§ 2 Überlassene Unterlagen</h2>
          <p>An allen im Zusammenhang mit der Auftragserteilung dem Besteller überlassenen Unterlagen, wie z.B. Kalkulationen, Zeichnungen etc. behalten wir uns das Eigentums- und Urheberrecht vor. Diese Unterlagen dürfen Dritten nicht zugänglich gemacht werden, es sei denn wir erteilen dem Besteller unsere ausdrückliche schriftliche Zustimmung. Soweit wir das Angebot des Bestellers nicht innerhalb der Frist von §1 annehmen, sind diese Unterlagen unverzüglich an uns zurück zu senden.</p>

          <h2>§ 3 Preise und Zahlung</h2>
          <ol>
            <li>Sofern nichts Gegenteiliges schriftlich vereinbart wird, gelten unsere Preise ab Werk ausschließlich Verpackung, Lieferung und Montage sowie zuzüglich Mehrwertsteuer in jeweils gültiger Höhe.</li>
            <li>Die Zahlung des Kaufpreises hat ausschließlich auf das umseitig genannte Konto zu erfolgen. Der Abzug von Skonto ist nur bei schriftlicher besonderer Vereinbarung zulässig.</li>
            <li>Sofern nichts anderes vereinbart wird ist der Kaufpreis innerhalb 5 Werktagen nach Rechnungsstellung zu bezahlen. Verzugszinsen werden in Höhe von 5% über dem jeweiligen Basiszinssatz berechnet. Die Geltendmachung eines höheren Verzugsschadens bleibt vorbehalten.</li>
          </ol>

          <h2>§ 4 Lieferzeit</h2>
          <p>Sofern keine exakten Liefertermine und kürzere oder längere Lieferzeiten ausdrücklich schriftlich vereinbart wurden beträgt die Lieferzeit 8 Wochen von Eingang der Bestellung an. Wird die Lieferung ohne eigenverschulden unmöglich (§275 BGB) sind wir von der Pflicht der Lieferung frei. Dies gilt besonders für Fälle von höherer Gewalt, Verkehrsstörungen, Betriebsstörungen, Streiks und Aussperrungen.</p>

          <h2>§ 5 Lieferungsverzug</h2>
          <p>Wurden fest vereinbarte Liefertermine und Lieferfristen von uns nicht eingehalten ist der Auftraggeber verpflichtet uns eine Nachfrist von 4 Wochen für die Lieferung gewähren. Nach Verstreichen dieser Nachfrist ist es dem Auftraggeber erlaubt von dem Kaufvertrag zurück zu treten.</p>

          <h2>§ 6 Eigentumsvorbehalt</h2>
          <ol>
            <li>Wir behalten uns das Eigentum an der gelieferten Sache bis zur vollständigen Zahlung aus dem Liefervertrag vor. Wir sind berechtigt, die Kaufsache zurückzunehmen, wenn der Besteller sich vertragswidrig verhält.</li>
            <li>Der Besteller ist verpflichtet, solange das Eigentum noch nicht auf ihn übergegangen ist, die Kaufsache pfleglich zu behandeln. Insbesondere ist er verpflichtet, diese auf eigene Kosten gegen Diebstahl-, Feuer- und Wasserschäden ausreichend zum Neuwert zu versichern.</li>
          </ol>

          <h2>§ 7 Gewährleistung und Mängelrüge</h2>
          <ol>
            <li>Soweit die in unseren Prospekten, Anzeigen und sonstigen Angebotsunterlagen enthaltenen Angaben nicht von uns ausdrücklich als verbindlich bezeichnet worden sind, sind die dort enthaltenen Abbildungen und Zeichnungen nur annähernd maßgebend.</li>
            <li>Soweit der gelieferte Gegenstand nicht die zwischen dem Besteller und uns vereinbarte Beschaffenheit hat oder sich nicht für die nach dem Vertrag vorausgesetzten oder die Verwendung allgemein eignet, sind wir zur Nacherfüllung verpflichtet.</li>
            <li>Der Besteller hat einen Nachbesserungsversuch zu tolerieren. Scheitert der Nachbesserungsversuch kann der Besteller eine Ersatzlieferung fordern.</li>
            <li>Ist die Nacherfüllung fehlgeschlagen oder wurde sie von unserer Seite her verweigert kann der Besteller eine Herabsetzung seines Kaufpreises (Minderung) verlangen oder den Rücktritt vom Vertrag erklären.</li>
            <li>Eine weitergehende Haftung ist ohne Rücksicht auf die Rechtsnatur des geltend gemachten Anspruchs ausgeschlossen.</li>
            <li>Die Gewährleistung beträgt 2 Jahre, gerechnet ab dem Gefahrübergang. Eine Ausnahmeregelung gilt für gebrauchte Waren, hier beträgt die Gewährleistungsfrist 1 Jahr gerechnet ab dem Gefahrübergang.</li>
          </ol>

          <h2>§ 8 Geltungsbereich</h2>
          <p>Soweit nicht anders oder ausdrücklich vereinbart, gelten die obigen Allgemeinen Geschäfts- und Lieferbedingungen.</p>

          <h2>§ 9 Sonstiges</h2>
          <ol>
            <li>Dieser Vertrag und die gesamten Rechtsbeziehungen der Parteien unterliegen dem Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts (CISG).</li>
            <li>Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein oder werden oder eine Lücke enthalten, so bleiben die übrigen Bestimmungen hiervon unberührt.</li>
            <li>Mündliche Nebenabreden sind für uns nicht verbindlich.</li>
            <li>Erfüllungsort und ausschließlicher Gerichtsstand von Bürokult GmbH, ist das für uns zuständige Amts- bzw. Landgericht.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default AGB;
